<template>
	<div class="h100 analyze_right">
		<div class="title">
			<el-form ref="addForm"
					 class="ef-form"
					 :model="addForm"
					 :rules="addRules"
					 label-width="80px">
				<el-row class="mt5">
					<el-col :span="15"
							class="el-left">
						<el-radio-group v-model="radio2"
										@change="clickRadio">
							<el-radio :label="1">当前价格</el-radio>
							<el-radio :label="2">环比涨跌幅</el-radio>
							<el-radio :label="3">同比涨跌幅</el-radio>
							<el-radio :label="4">价格走势</el-radio>
						</el-radio-group>
					</el-col>
					<el-col :span="9"
							class="el-col-flex">
						<el-form ref="addForm"
								 class="inner-form"
								 label-width="80px">
							<el-row>
								<el-col :span="10"
										v-show="currentRadio === 2 || currentRadio === 3">
									<el-form-item label="基数"
												  prop="baseMonth">
										<el-date-picker v-model="addForm.baseMonth"
														@change="timeChange($event,currentRadio)"
														type="month"
														value-format="yyyy-MM"
														placeholder="所属月份">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="10"
										v-show="currentRadio === 1 || currentRadio === 2 || currentRadio === 3">
									<el-form-item label="当期"
												  prop="yearAndMonth">
										<el-date-picker v-model="addForm.yearAndMonth"
														@change="timeChange($event,currentRadio)"
														type="month"
														value-format="yyyy-MM"
														placeholder="所属月份">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="20"
										v-show="currentRadio === 4">
									<el-form-item label="时间区间"
												  prop="busImpList">
										<el-date-picker v-model="addForm.busImpList"
														@change="timeChange($event,currentRadio)"
														align="right"
														type="monthrange"
														format="yyyy 年 MM"
														value-format="yyyy-MM"
														unlink-panels
														range-separator="至"
														start-placeholder="开始日期"
														end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="4"
										class="margin">
									<el-button type="primary"
											   size="small"
											   @click="exportChange">导出图片</el-button>
								</el-col>
							</el-row>
						</el-form>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="ishow"
			 v-show="currentRadio === 4">
			<el-radio-group v-model="radio"
							@change="clickTrend">
				<el-radio :label="1">价格</el-radio>
				<el-radio :label="2">幅度</el-radio>
			</el-radio-group>
		</div>

		<div v-show="currentRadio === 1"
			 class="content-echart"
			 id="currentRadioOne">
		</div>

		<div v-show="currentRadio === 2 || currentRadio === 3"
			 class="content-echart"
			 id="RegionRadioOne">
		</div>

		<div v-show="currentRadio === 4 && radio === 1"
			 class="price-echart"
			 id="priceRadioOne">
		</div>

		<div v-show="currentRadio === 4 && radio === 2"
			 class="price-echart"
			 id="rangeTrendOne">
		</div>

		<!-- 弹窗点击下载图片 -->
		<el-dialog :title="dialogModel.title"
				   :visible.sync="dialogModel.visible"
				   :width="dialogModel.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<div class="text-center h100 overflow-hidden"
				 style="width:100%;height:500px"
				 id="enlarge_echart">
			</div>
			<!-- 底部按钮 -->
			<div slot="footer"
				 v-if="dialogModel.type === 'add'"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">下载图片</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	currentPriceInRegion,
	professionUpAndDownInRegion,
	priceTrend,
	rangeTrend
} from '@/api/modules/analyze_tab'
import { dateFormat } from '@/utils/tools.js'
export default {
	name: 'Regional_analysis_right',
	props: {
		//当前地区
		activeName: {
			type: String,
			default: ''
		},
		//当前地区名
		cityName: {
			type: String,
			default: ''
		},
		//信息市场价
		priceType: {
			type: Number,
			default: null
		},
		//工种编码
		codesList: {
			type: Array,
			default: {}
		}
	},
	data() {
		return {
			radio: 1,
			radio2: 1,
			currentRadio: 1,
			addForm: {
				busImpList: [], // 起止日期数组
				yearAndMonth: '', //当期
				baseMonth: '', //基数
				startTime: '',
				endTime: ''
			},
			// 弹窗对象
			dialogModel: {
				title: '预览图表',
				visible: false,
				width: '80%',
				type: 'add'
			},
			btnLoading: false,
			addRules: {},
			codeSname: [],
			codePrice: [],
			yearMonth: [],
			priceList: [],
			priceData: [],
			snameList: [],
			textTitle: ''
		}
	},
	created() {},
	mounted() {
		//获取当前价格初始化数据
		this.$nextTick(() => {})
	},
	methods: {
		//时间事件
		timeChange(e, index) {
			switch (index) {
				case 1:
					this.addForm.yearAndMonth = e
					if (this.codesList) {
						this.initChart()
					}
					break
				case 2:
					if (this.addForm.baseMonth >= this.addForm.yearAndMonth) {
						this.$message.warning('基数时间不能大于当期时间')
						return
					}
					this.getRegionRadioOne()
					break
				case 3:
					let that = this
					if (that.addForm.baseMonth >= that.addForm.yearAndMonth) {
						that.$message.warning('基数时间不能大于当期时间')
						return
					}
					this.getRegionRadioOne()
					break
				default:
					this.addForm.startTime = e[0]
					this.addForm.endTime = e[1]
					if (this.radio === 1) {
						this.getPriceRadioOne()
					} else {
						this.getTangeTrendOne()
					}
			}
		},

		//radio点击事件
		clickRadio(val) {
			this.$emit('on-radio-change', val)
			this.currentRadio = val
			this.addForm.busImpList = []
			switch (val) {
				case 1:
					let month = dateFormat().substring(0, 7)
					this.addForm.yearAndMonth = month
					setTimeout(() => {
						this.initChart()
					}, 100)
					break
				case 2:
					let oneYear = new Date().getFullYear(),
						onemonth = new Date().getMonth()
					if (onemonth < 10) {
						onemonth = '0' + onemonth
					}
					this.addForm.baseMonth = oneYear + '-' + onemonth
					setTimeout(() => {
						this.getRegionRadioOne()
					}, 100)
					break
				case 3:
					let lastYear = new Date().getFullYear() - 1,
						lastmonth = new Date().getMonth() + 1
					if (lastmonth < 10) {
						lastmonth = '0' + lastmonth
					}
					this.addForm.baseMonth = lastYear + '-' + lastmonth
					setTimeout(() => {
						this.getRegionRadioOne()
					}, 100)
					break
				default:
					let fullYear = new Date().getFullYear(),
						fullStartmonth = new Date().getMonth() - 4,
						fullEedmonth = new Date().getMonth() - 5,
						fullStarttimes = [],
						fullEedtimes = []
					if (fullStartmonth < 10) {
						fullStartmonth = '0' + fullStartmonth
					}
					if (fullEedmonth < 10) {
						fullEedmonth = '0' + fullEedmonth
					}

					fullStarttimes.push(fullYear, fullStartmonth)
					fullEedtimes.push(fullYear + 1, fullEedmonth)
					this.addForm.startTime = fullStarttimes.join('-')
					this.addForm.endTime = fullEedtimes.join('-')
					this.addForm.busImpList.push(
						this.addForm.startTime,
						this.addForm.endTime
					)
					setTimeout(() => {
						this.getPriceRadioOne()
					}, 300)
			}
		},

		//价格幅度点击事件
		clickTrend(val) {
			this.$emit('on-second-radio', val)
			if (this.radio === 1) {
				setTimeout(() => {
					this.getPriceRadioOne()
				}, 300)
			} else {
				setTimeout(() => {
					this.getTangeTrendOne()
				}, 300)
			}
		},

		//导出图片
		exportChange() {
			this.dialogModel.visible = true
			this.dialogModel.type = 'add'
			switch (this.currentRadio) {
				case 1:
					setTimeout(() => {
						this.initChart('111')
					}, 200)
					break
				case 2:
					setTimeout(() => {
						this.getRegionRadioOne('111')
					}, 200)
					break
				case 3:
					setTimeout(() => {
						this.getRegionRadioOne('222')
					}, 200)
					break
				case 4:
					setTimeout(() => {
						if (this.radio === 1) {
							this.getPriceRadioOne('222')
						} else {
							this.getTangeTrendOne('333')
						}
					}, 200)
					break
			}
		},

		//获取当前价格
		initChart(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('currentRadioOne')
			let currentRadioOne = this.$echarts.init(dom),
				option = {},
				RadioName = '当前价格'
			currentRadioOne.showLoading()
			currentPriceInRegion({
				city: this.activeName,
				currentPeriod: this.addForm.yearAndMonth,
				codes: this.codesList,
				priceType: this.priceType
			})
				.then(res => {
					if (res.code === 0) {
						currentRadioOne.hideLoading()
						this.codeSname = res.data.map(v => {
							return v.sname
						})
						this.codePrice = res.data.map(v => {
							return v.price
						})
					} else {
						this.$Message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							color: ['#c8bd7e'],
							title: {
								text: val
									? (this.textTitle =
											this.addForm.yearAndMonth +
											'' +
											this.cityName +
											'工种' +
											RadioName)
									: '',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位(元)',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'item',
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
											'</br>' +
											x.marker +
											' ' +
											x.value +
											' %'
									})
									return str
								},
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: [
								{
									type: 'category',
									data: this.codeSname,
									axisTick: {
										alignWithLabel: true
									},
									axisLabel: {
										interval: 0, //强制文字产生间隔
										rotate: 45, //文字逆时针旋转45°
										textStyle: {
											//文字样式
											fontSize: 14,
											fontFamily: 'Microsoft YaHei'
										}
									}
								}
							],
							yAxis: [
								{
									type: 'value'
								}
							],
							series: [
								{
									type: 'bar',
									barWidth: '20%',
									data: this.codePrice,
									label: {
										show: true,
										fontSize: 14,
										position: 'top',
										color: '#199ed8',
										formatter: params => {
											return '' + params.value + '元'
										}
									}
								}
							]
						}
						currentRadioOne.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							currentRadioOne.setOption(option, true)
							window.addEventListener('resize', () => {
								currentRadioOne.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//环比涨跌幅和同比涨跌幅
		getRegionRadioOne(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('RegionRadioOne')
			let RegionRadioOne = this.$echarts.init(dom),
				option = {},
				RadioName = this.radio2 === 2 ? '环比涨跌幅' : '同比涨跌幅'
			RegionRadioOne.showLoading()
			professionUpAndDownInRegion({
				city: this.activeName,
				currentPeriod: this.addForm.yearAndMonth,
				codes: this.codesList,
				priceType: this.priceType,
				basePeriod: this.addForm.baseMonth
			})
				.then(res => {
					if (res.code === 0) {
						RegionRadioOne.hideLoading()
						this.codeSname = res.data.map(v => {
							return v.sname
						})
						this.codePrice = res.data.map(v => {
							return v.range
						})
					} else {
						this.$Message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							color: ['#c8bd7e'],
							title: {
								text: val
									? (this.textTitle =
											this.addForm.baseMonth +
											'~' +
											this.addForm.yearAndMonth +
											'' +
											this.cityName +
											'工种' +
											RadioName)
									: '',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位(%)',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
											'</br>' +
											x.marker +
											' ' +
											x.value +
											' %'
									})
									return str
								},
								textStyle: {
									align: 'left'
								}
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: [
								{
									type: 'category',
									data: this.codeSname,
									axisTick: {
										alignWithLabel: true
									},
									axisLabel: {
										interval: 0, //强制文字产生间隔
										rotate: 45, //文字逆时针旋转45°
										textStyle: {
											//文字样式
											fontSize: 14,
											fontFamily: 'Microsoft YaHei'
										}
									}
								}
							],
							yAxis: [
								{
									type: 'value'
								}
							],
							series: [
								{
									type: 'bar',
									barWidth: '20%',
									data: this.codePrice,
									label: {
										show: true,
										fontSize: 14,
										position: 'top',
										color: '#199ed8',
										formatter: params => {
											return '' + params.value + '%'
										}
									}
								}
							]
						}
						RegionRadioOne.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							RegionRadioOne.setOption(option, true)
							window.addEventListener('resize', () => {
								RegionRadioOne.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//价格走势 价格
		getPriceRadioOne(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('priceRadioOne')
			let priceRadioOne = this.$echarts.init(dom),
				option = {},
				RadioName = '价格走势',
				that = this
			priceRadioOne.showLoading()
			priceTrend({
				city: this.activeName,
				basePeriod: this.addForm.startTime,
				codes: this.codesList,
				priceType: this.priceType,
				currentPeriod: this.addForm.endTime
			})
				.then(res => {
					if (res.code === 0) {
						priceRadioOne.hideLoading()
						that.yearMonth = res.data.yearmonths
						that.snameList = res.data.priceList.map(v => {
							return v.name
						})
						that.priceData = []
						res.data.priceList.forEach(item => {
							that.priceData.push({
								name: item.name,
								type: 'line',
								barGap: 0,
								data: item.data
							})
						})
					} else {
						this.$Message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							title: {
								text: val
									? (this.textTitle =
											this.addForm.startTime +
											'~' +
											this.addForm.endTime +
											'' +
											this.cityName +
											'工种' +
											RadioName)
									: '',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位（元）',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
											'</br>' +
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								}
							},
							legend: {
								data: that.snameList,
								left: '10%',
								top: val ? '5%' : 10,
								type: 'scroll'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: that.yearMonth
							},
							yAxis: {
								type: 'value'
							},
							series: that.priceData
						}
						priceRadioOne.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							priceRadioOne.setOption(option, true)
							window.addEventListener('resize', () => {
								priceRadioOne.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//价格走势 涨幅
		getTangeTrendOne(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('rangeTrendOne')
			let rangeTrendOne = this.$echarts.init(dom),
				option = {},
				RadioName = '幅度走势',
				that = this
			rangeTrendOne.showLoading()
			rangeTrend({
				city: this.activeName,
				basePeriod: this.addForm.startTime,
				codes: this.codesList,
				priceType: this.priceType,
				currentPeriod: this.addForm.endTime
			})
				.then(res => {
					if (res.code === 0) {
						rangeTrendOne.hideLoading()
						that.yearMonth = res.data.yearmonths
						that.snameList = res.data.rangeList.map(v => {
							return v.name
						})
						that.priceData = []
						res.data.rangeList.forEach(item => {
							that.priceData.push({
								name: item.name,
								type: 'line',
								barGap: 0,
								data: item.data
							})
						})
					} else {
						this.$message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							title: {
								text: val
									? (this.textTitle =
											this.addForm.startTime +
											'~' +
											this.addForm.endTime +
											'' +
											this.cityName +
											'工种' +
											RadioName)
									: '',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位（元）',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
											'</br>' +
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								},
								textStyle: {
									align: 'left'
								}
							},
							legend: {
								data: that.snameList,
								left: '10%',
								top: val ? '5%' : 10,
								type: 'scroll'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: that.yearMonth
							},
							yAxis: {
								type: 'value'
							},
							series: that.priceData
						}
						rangeTrendOne.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							rangeTrendOne.setOption(option, true)
							window.addEventListener('resize', () => {
								rangeTrendOne.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogModel.visible = false
		},

		//确定事件
		doConfirm() {
			let echartLarge = this.$echarts.init(
				document.getElementById('enlarge_echart')
			)
			this.$emit('on-Download-pictures', echartLarge, this.textTitle)
		}
	},
	computed: {},
	watch: {
		cityName: {
			handler(val) {
				this.cityName = val
			},
			deep: true
		},
		codesList: {
			handler(val) {
				this.codesList = val
			},
			immediate: true
		},
		activeName: {
			handler(val) {
				this.activeName = val
			},
			deep: true
		},
		priceType: {
			handler(val) {
				this.priceType = val
				switch (this.currentRadio) {
					case 1:
						this.initChart()
						break
					case 2:
						this.getRegionRadioOne()
						break
					case 3:
						this.getRegionRadioOne()
						break
					default:
						if (this.radio === 1) {
							this.getPriceRadioOne()
						} else {
							this.getTangeTrendOne()
						}
				}
			},
			deep: true
		}
	}
}
</script>
<style scoped lang="less">
.analyze_right {
	.title {
		display: flex;
		flex-flow: column;
		width: 100%;
		padding: 0 0 0 20px;
		box-sizing: border-box;
		.ef-form {
			width: 100%;
			.el-row {
				width: 100%;
				display: flex;
				-webkit-box-pack: end;
				-ms-flex-pack: end;
				justify-content: flex-end;
			}
		}
		.el-col-flex {
			flex: 1;
		}
	}
	.ishow {
		width: 100%;
		height: 32px;
		line-height: 32px;
		text-align: center;
	}
	.content-echart {
		height: calc(100% - 37px);
		width: 100%;
	}
	.price-echart {
		height: calc(100% - 69px);
		width: 100%;
	}
	.el-right {
		flex: 1;
		text-align: right;
	}
}
</style>